import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {SizeBubble} from '../../atoms/SizeBubble/SizeBubble';
import {Text} from '../../atoms/Text';
import {HorizontalList} from '../HorizontalList/HorizontalList';

interface SoldOut {
  $case: 'soldOut';
  soldOut: {};
}

interface InStock {
  $case: 'inStock';
  inStock: {};
}

export const SizeBubbleList = ({
  sizes,
  selectedSizeIds,
  onSizeSelect,
  showOutOfStock,
  showRecommendedSize,
  recommendedSizeId,
  isInlineSizeQuickViewEnabled,
  ref: forwardedRef,
}: {
  sizes: Array<{
    sizeId: number;
    label: string;
    availability?: SoldOut | InStock;
  }>;
  label?: string;
  selectedSizeIds: number[];
  onSizeSelect: (id: number) => void;
  showOutOfStock?: boolean;
  showRecommendedSize?: boolean;
  recommendedSizeId?: number;
  isInlineSizeQuickViewEnabled?: boolean;
  ref?: React.Ref<HTMLElement>;
}) => {
  const {t} = useTranslation();

  return (
    <>
      <Headline
        size={!isInlineSizeQuickViewEnabled ? 'px16' : 'px12'}
        weight={!isInlineSizeQuickViewEnabled ? 'bold' : 'mediumHeavy'}
        $topMargin={!isInlineSizeQuickViewEnabled}
      >
        {t('Select size')}
      </Headline>
      <Slider $smallerMarginTop={isInlineSizeQuickViewEnabled}>
        <HorizontalList ref={forwardedRef}>
          {sizes.map(size => {
            const isActive = selectedSizeIds.includes(size.sizeId);
            return (
              <StyledSizeBubble
                isInlineSizeQuickViewEnabled={isInlineSizeQuickViewEnabled}
                size={size}
                active={isActive}
                onClick={onSizeSelect}
                key={size.sizeId}
                showOutOfStock={showOutOfStock}
                showRecommendedSize={showRecommendedSize}
                recommendedSizeId={recommendedSizeId}
                isOutOfStock={size.availability?.$case === 'soldOut'}
              />
            );
          })}
        </HorizontalList>
      </Slider>
    </>
  );
};

const Headline = styled(Text)<{$topMargin?: boolean}>`
  display: block;
  ${props => (props.$topMargin ? 'margin-top: 1.5rem;' : '')}
`;

const Slider = styled.div<{$smallerMarginTop?: boolean}>`
  margin-top: ${props => (props.$smallerMarginTop ? '8px' : '1rem')};
`;

const StyledSizeBubble = styled(SizeBubble)`
  margin-right: 10px;
  color: ${COLORS.Black};
`;
